import React from 'react'

export default function Blinking(props) {
    const {fontSize} = props
    return (
        <span className="saving">
            <span style={{"fontSize": fontSize}}>.</span>
            <span style={{"fontSize": fontSize}}>.</span>
            <span style={{"fontSize": fontSize}}>.</span>
        </span>
    )
}
